<template>
  <el-form
    ref="registerForm"
    class="registerForm"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onSubmit"
  >
    <!-- GENDER -->
    <el-form-item
      class="registerForm__gender"
      :label="$t('auth.register.form.civilityLabel')"
    >
      <el-radio-group v-model="form.gender">
        <el-radio :label="'male'">{{$t('auth.register.form.civilityMale')}}</el-radio>
        <el-radio :label="'female'">{{ $t('auth.register.form.civilityFemale') }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- FIRSTNAME & LASTNAME -->
    <el-form-item
      :label="$t('auth.register.form.lastNameLabel')"
      prop="last_name"
    >
      <el-input
        v-model="form.last_name"
        name="last_name"
				onkeyup="this.value=this.value.toUpperCase()"
				class="uppercase"
        :placeholder="$t('auth.register.form.lastNamePlaceholder')"
      />
    </el-form-item>
    <el-form-item
      :label="$t('auth.register.form.firstNameLabel')"
      prop="first_name"
    >
      <el-input
        v-model="form.first_name"
        name="first_name"
        :placeholder="$t('auth.register.form.firstNamePlaceholder')"
      />
    </el-form-item>
    <!-- EMAIL & PASSWORD -->
    <el-form-item
      :label="$t('auth.register.form.passwordLabel')"
      prop="password"
    >
      <el-input
        v-model="form.password"
        show-password
        type="password"
        name="password"
        :placeholder="$t('auth.register.form.passwordPlaceholder')"
      />
    </el-form-item>
    <el-form-item
      :label="$t('auth.register.form.emailLabel')"
      prop="email"
    >
      <el-input
        v-model="form.email"
        name="email"
        :placeholder="$t('auth.register.form.emailPlaceholder')"
      />
    </el-form-item>
    <el-form-item
      :label="$t('auth.register.form.phoneNumberLabel')"
      prop="phone_number"
    >
      <phone-input
        v-model="phone"
        @update="updatePhone"
      />
    </el-form-item>

    <!-- Partner code -->
    <el-form-item prop="partner_code">
      <el-tooltip
        effect="light"
        :content="$t('auth.register.form.partnerCodeToolTip')"
        placement="right-end"
      >
        <label
          class="el-form-item__label"
          for="partner_code"
        >{{ $t('auth.register.form.partnerCodeLabel') }}</label>
      </el-tooltip>
      <el-input
        v-model="form.partner_code"
        type="text"
        name="partner_code"
        :placeholder="$t('auth.register.form.partnerCodePlaceHolder')"
        @blur="validatePartnerCodeFormat"
      />
    </el-form-item>

		<!-- <vue-recaptcha 
			ref="invisibleRecaptcha"
			:sitekey="recaptchaKey"
			badge>
		</vue-recaptcha> -->
		
    <!-- CGU -->
    <el-form-item
      class="registerForm__options"
      prop="cgu"
    >
      <div class="registerForm__options-cgu">
        <el-checkbox v-model="form.cgu">
          <span class="registerForm__options-cgu-label">{{ $t('auth.register.form.cguLabel') }}</span>
        </el-checkbox>
      </div>
    </el-form-item>

    <p class="cgu-agreement-text">
      {{ $t('auth.register.form.cguConsentAgreement') }}
      <a
        class="cgu-link"
        :href="$t('footer.cguLink')"
        target="_blank"
      >{{ $t('auth.register.form.cguConsentAgreementLinkText') }}</a>
    </p>


    <div class="registerForm__submit">
			<el-button
				:type="form.gender && form.last_name && form.first_name && form.password && form.email && form.phone_number && form.cgu ? 'primary' : 'default'"
				:loading="loading"
				native-type="submit"
			>{{ $t('auth.register.form.submitButton') }}</el-button>
    </div>
  </el-form>
</template>

<script>
import PhoneInput from '@/components/ui/PhoneInput'
import { mapState } from 'vuex'

export default {
	name: 'RegisterForm',
	components: {
		// VueRecaptcha,
		PhoneInput
	},
	data: () => ({
		recaptchaKey: '6Lf2RI8iAAAAAODDOgrsLxFpcXcEqyxL33vdGNjZ',
		loading: false,
		partner_code_error: false,
		form: {
			gender: 'male',
			first_name: null,
			last_name: null,
			phone_number: null,
			phone_country_code: null,
			email: null,
			password: null,
			cgu: null,
			partner_code: null
		}
	}),
	computed: {
		...mapState({
			availability: state => state.residences.selectedAvailability
		}),
		rules() {
			return {
				email: {
					type: 'email',
					required: true,
					trigger: 'blur',
					message: this.$t('forms.validation.invalidEmail')
				},
				gender: {
					type: 'string',
					required: true,
					message: this.$t('forms.validation.invalidGender')
				},
				first_name: {
					type: 'string',
					required: true,
					message: this.$t('forms.validation.invalidFirstName')
				},
				last_name: {
					type: 'string',
					required: true,
					message: this.$t('forms.validation.invalidLastName')
				},
				password: {
					type: 'string',
					required: true,
					validator: this.$helpers.passwordValidator
				},
				phone_number: {
					type: 'string',
					required: true,
					message: this.$t('forms.validation.invalidPhoneNumber')
				},
				cgu: {
					type: 'boolean',
					required: true,
					message: this.$t('forms.validation.invalidCgu')
				}
			}
		},
		phone() {
			return {
				localValue: this.form.phone_number,
				countryCode: this.form.phone_country_code
			}
		}
	},
	watch: {
		'form.cgu': {
			handler(newVal) {
				if (newVal === false) {
					this.form.cgu = null
				}
			}
		}
	},
	methods: {
		updatePhone(event) {
			this.form.phone_number = event.phoneNumber
			this.form.phone_country_code = event.countryCode
		},
		validatePartnerCodeFormat() {
			if (!this.form.partner_code) return
			const regex = /^[\w-]+$/
			const found = this.form.partner_code.match(regex)
			if (!found) {
				return this.$notify({
					type: 'error',
					title: this.$t('base.errors.notificationTitle'),
					message: this.$t('auth.register.form.partnerCodeInvalidFormatError')
				})
			}
			return this.validatePartnerCode()
		},
		async validatePartnerCode() {
			try {
				const res = await this.$api.partnersCode.getPartnersCodeValidation({
					code: this.form.partner_code
				})
				if (res === undefined) {
					this.partner_code_error = true
					return this.$notify({
						type: 'error',
						title: this.$t('base.errors.notificationTitle'),
						message: this.$t('auth.register.form.partnerCodeError')
					})
				}
				this.partner_code_error = false
			} catch (error) {
				this.partner_code_error = true
				this.$notify({
					type: 'error',
					title: this.$t('base.errors.notificationTitle'),
					message: this.$t('base.errors.defaultMessage')
				})
			}
		},
		async onSubmit() {
			if (this.form.partner_code && this.partner_code_error) {
				return this.$notify({
					type: 'error',
					title: this.$t('base.errors.notificationTitle'),
					message: this.$t('auth.register.form.partnerCodeError')
				})
			}
			try {
				this.loading = true
				const validation = await this.$refs['registerForm'].validate()

				if (this.form.cgu && validation) {
					// this.$refs.invisibleRecaptcha.execute()

					const { ...registration } = this.form

					if (this.$route.params.code) {
						registration.offer_booking_restriction_code = this.$route.params.code
					}

					const res = await this.$store.dispatch('customer/register', {
						availability_id: this.availability ? this.availability.id : null,
						registration
					})
					this.loading = false
					if (res === undefined) return
					this.$router.push({
						name: 'login',
						params: {
							registered: true
						}
					})
					this.$notify({
						type: 'success',
						title: this.$t('base.success.notificationTitle'),
						message: this.$t('auth.register.form.success')
					})
				}
			} catch (error) {
				this.loading = false
			}
		}
	}
}
</script>

<style scoped lang="scss">
$c: '.registerForm';
#{$c} {
	width: 100%;
	&__gender {
		text-align: left;
	}

	&__options {
		text-align: right;

		&__options-cgu {
			&-label {
				font-size: 14px;
			}
		}

		.el-form-item__content {
			.el-form-item__error {
				right: 0 !important;
			}
		}
	}

	&__submit {
		margin-top: 24px;
		text-align: right;
	}
}

.cgu-link {
	color: #606266;
	text-decoration: underline;
}
.cgu-link:hover {
	color: #f4b452;
}

.cgu-agreement-text {
	color: #999999;
	font-size: 11px;
}

.registerForm__options {
	.el-form-item__error {
		position: relative !important;
	}
}

</style>
